import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "api";
import { proceedThunk } from "./utils";

export const projectsListThunk = createAsyncThunk(
  "project/list",
  proceedThunk(api.takebaker.projects.list)
);

export const fetchProjectThunk = createAsyncThunk(
  "project/fetch",
  proceedThunk(api.takebaker.projects.get)
);

export const fetchProjectByUrlThunk = createAsyncThunk(
  "project/fetchByUrl",
  proceedThunk(api.takebaker.projects.getByUrl)
);

export const createProjectThunk = createAsyncThunk(
  "project/create",
  proceedThunk(api.takebaker.projects.create)
);

export const updateProjectThunk = createAsyncThunk(
  "project/update",
  proceedThunk(api.takebaker.projects.update)
);

export const renameProjectThunk = createAsyncThunk(
  "project/rename",
  proceedThunk(api.takebaker.projects.rename)
);

export const deleteProjectThunk = createAsyncThunk(
  "project/delete",
  async (payload, { rejectWithValue }) => {
    const response = await api.takebaker.projects.delete(payload);
    const data = await response.json();
    if (!response.ok) {
      const error = data.detail;
      return rejectWithValue(error);
    }
    return { projectId: data.id };
  }
);

export const exportProjectThunk = createAsyncThunk(
  "project/export",
  async (payload, { rejectWithValue }) => {
    const response = await api.takebaker.projects.download(payload);
    if (!response.ok) {
      const body = await response.json();
      return rejectWithValue(body);
    }

    const contentDisposition = response.headers.get("content-disposition");
    const filenameIndex =
      contentDisposition.indexOf(`filename=`) + "filename=".length;
    const filename = contentDisposition.substr(filenameIndex);

    return { filename, blob: await response.blob() };
  }
);

export const statsProjectThunk = createAsyncThunk(
  "project/stats",
  proceedThunk(api.takebaker.projects.stats)
);

export const searchProjectsThunk = createAsyncThunk(
  "project/search",
  proceedThunk(api.takebaker.projects.search)
);

export const projectsInitialSearchListThunk = createAsyncThunk(
  "project/search/initialList",
  proceedThunk(api.takebaker.projects.list)
);
